import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { DynamicPageMutationKeys } from '../../../keys'
import { AddSectionToPageRequest } from '../../../type'
import { addSectionToPage } from '../../services'

interface UseMutationAddSectionToPageProps {
	payload: AddSectionToPageRequest
}

export default function useMutationAddSectionToPage(
	props?: UseBaseMutationOptions<void, UseMutationAddSectionToPageProps>,
) {
	return useMutation({
		mutationKey: [DynamicPageMutationKeys.AddSectionToPage],
		mutationFn: (params) => addSectionToPage(params.payload),
		...props,
	})
}
